// 生产环境
let config = {
  // baseUrl: 'https://edu-test.ykumda.com/gateway', // 开发网关地址
  baseUrl: 'https://edu.shanxiyixue.com/gateway', // 生产网关地址
  // baseUrl: 'https://edu.4e-edu.cn/gateway', // 生产网关地址
  // baseUrl: 'http://localhost:9900',
  // baseUrl: 'http://192.168.10.22:9900',
  // baseUrl: 'http://192.168.10.139:9900',
  // url: 'edu-test.ykumda.com', // 店铺域名，本地开发使用，生产不用配置该属性
  url: 'edu.shanxiyixue.com',
  // url: 'edu.4e-edu.cn',
  // H5 实人认证结果页根地址（history base=/h5/）；须与实际 H5 部署域名一致
  // h5BaseUrl: 'https://edu-test.ykumda.com/h5',
  h5BaseUrl: 'https://edu.shanxiyixue.com/h5',
  tokenName: 'EDU_WEB_TOKEN',
  tokenExpires: 60 * 60 * 1000, // token 过期时间为1个小时
  // 职业技能培训店；有值时 Web 端请求强制走该 sid（专属登录域名上线后可置空）
  // trainShopId: ''
}

if (process.env.NODE_ENV === 'development') {
  // 开发环境
  config = {
    ...config,
    // baseUrl: 'http://localhost:9900',
    //  baseUrl: 'http://192.168.10.143:9900',
    // baseUrl: 'http://192.168.10.226:9900',
    // baseUrl: 'https://edu-test.ykumda.com/gateway', // 开发网关地址
    // baseUrl: 'http://localhost:9900',
    baseUrl: 'https://edu.shanxiyixue.com/gateway',
    // baseUrl: 'http://192.168.10.226:9900',
    // url: 'edu-test.ykumda.com', // 店铺域名，本地开发使用，生产不用配置该属性
    url: 'edu.shanxiyixue.com',
    // url: 'peixun.ykumda.com',
    // url: 'aufe.ykumda.com'
    // h5BaseUrl: 'https://edu-test.ykumda.com/h5',
    h5BaseUrl: 'https://edu.shanxiyixue.com/h5',
    // trainShopId: '2080836403267747841'
  }
}
export default config
